import * as actionTypes from 'modules/audits/actionTypes';
import { SELECT_SOURCE } from 'modules/audits/constants';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

const startAuditsFetch = (state, { meta }) => (meta?.source === SELECT_SOURCE ? state : true);
const endAuditsFetch = (state, { meta }) => (meta?.source === SELECT_SOURCE ? state : false);

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_REQUEST]: startAuditsFetch,
  [actionTypes.FETCH_AUDIT_REQUEST]: isLoading,
  [actionTypes.PUT_REQUEST]: isLoading,
  [actionTypes.POST_CLONE_REQUEST]: isLoading,
  [actionTypes.PATCH_STATUS_REQUEST]: isLoading,
  [actionTypes.DELETE_REQUEST]: isLoading,
  [actionTypes.POST_REQUEST]: isLoading,
  [actionTypes.FETCH_AUDITS_SUCCESS]: endAuditsFetch,
  [actionTypes.FETCH_AUDIT_SUCCESS]: isEnding,
  [actionTypes.POST_CLONE_SUCCESS]: isEnding,
  [actionTypes.PATCH_STATUS_SUCCESS]: isEnding,
  [actionTypes.PUT_REQUEST]: isLoading,
  [actionTypes.PUT_SUCCESS]: isEnding,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.FETCH_AUDITS_FAILURE]: endAuditsFetch,
  [actionTypes.FETCH_AUDIT_FAILURE]: isEnding,
  [actionTypes.PUT_FAILURE]: isEnding,
  [actionTypes.POST_CLONE_FAILURE]: isEnding,
  [actionTypes.PATCH_STATUS_FAILURE]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
  [actionTypes.POST_SUCCESS]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
});
